import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { toast } from 'react-toastify';
import { sessionExpired } from './userSlice';

const API_BASE = process.env.REACT_APP_SLDL_TESTING_ENVIRONMENT_API_BASE_URL;

const rawBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("token");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const clearSession = (api) => {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  api.dispatch(sessionExpired());
  toast.info("Your session has expired. Please sign in again.");
};

let refreshPromise = null;

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await rawBaseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
      clearSession(api);
      return result;
    }

    if (!refreshPromise) {
      refreshPromise = rawBaseQuery(
        {
          url: "auth/refresh-token",
          method: "POST",
          body: { refreshToken },
        },
        api,
        extraOptions
      ).finally(() => {
        refreshPromise = null;
      });
    }

    const refreshResult = await refreshPromise;
    const newToken = refreshResult?.data?.token;

    if (newToken) {
      localStorage.setItem("token", newToken);
      if (refreshResult.data.refreshToken) {
        localStorage.setItem("refreshToken", refreshResult.data.refreshToken);
      }
      result = await rawBaseQuery(args, api, extraOptions);
    } else {
      clearSession(api);
    }
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Paper"],
  endpoints: () => ({}),
});
